import {InjectionToken} from '@angular/core';
import {Preferences} from '@capacitor/preferences';
import {AppPackageInfoPlugin} from '../app-package-info/app-package-info.plugin';

export const WEB_VERSION_HINT_NATIVE = new InjectionToken<
  Pick<typeof AppPackageInfoPlugin, 'getInfo'> & Pick<typeof Preferences, 'get' | 'set'>
>('WEB_VERSION_HINT_NATIVE', {
  providedIn: 'root',
  factory: () => ({
    getInfo: () => AppPackageInfoPlugin.getInfo(),
    get: options => Preferences.get(options),
    set: options => Preferences.set(options),
  }),
});
